<template>
  <section>
    <v-card
      elevation="1"
      color="#FFF"
    >
      <v-card-title>
        <p class="process-header">
          Contract Progress
        </p>
      </v-card-title>
      <v-card-text class="justify-center">
        <v-form
          ref="form"
          v-model="valid"
        >
          <div class="progress-linear-style">
            <v-progress-linear
              v-model="currentContractProgress"
              height="40"
              color="#BDBDBD"
              light
              rounded
            >
              <strong>{{ Math.ceil(currentContractProgress) }}%</strong>
            </v-progress-linear>
          </div>
          <br>
          <v-text-field
            v-model="updatedContractProgress"
            dense
            filled
            hint="Contract progress value."
            persistent-hint
            class="field-text-style"
            inputmode="numeric"
            color="#37474F"
            light
            outlined
            label="Update Contract Progress*"
          />
        </v-form>
      </v-card-text>
    </v-card>
    <v-btn
      color="#000"
      class="mt-5 btn-style"
      elevation="0"
      @click="contractProgressGathered()"
    >
      Next
    </v-btn>
    <v-btn
      light
      color="#E6E6E6"
      class="mt-3 btn-style"
      elevation="0"
      @click="cancel()"
    >
      Cancel
    </v-btn>
    <centre-spinner
      :loading="loading"
    />
  </section>
</template>
  <script>
  import spinner from 'src/views/components/SpinnerCentre';
  import Constants from 'src/constants';
  export default {
    name: 'GatherContractProgress',
    components: {
      'centre-spinner': spinner,
    },
    data: () => ({
      loading: false,
      cardBgImg: require('@/assets/img/cardBg.png'),
      valid: false,
      updatedContractProgress: null,
      currentContractProgress: 0,
    }),
    computed: {
      userDetails () {
        return this.$store.getters.getUser;
      },
      activeCheckInDetails () {
        return this.$store.getters['swiftuser/getActiveCheckInDetails'];
      },
      locationName () {
        return this.$store.getters['swiftuser/getLocationName'];
      },
    },
    mounted () {
      this.loading = true;
      setTimeout(() => {
          this.currentContractProgress = this.activeCheckInDetails.contract_details.contract.contract_progress;
          this.updatedContractProgress = this.activeCheckInDetails.contract_details.contract.contract_progress;
          this.loading = false;
      }, 1000);
    },
    methods: {
      contractProgressGathered () {
        if (this.updatedContractProgress === null || this.updatedContractProgress === '') {
          this.$store.dispatch('alert/onAlert', {
            message: 'Contract progress value should not be left empty.',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
          return;
        }
        if (parseInt(this.updatedContractProgress) < parseInt(this.currentContractProgress)) {
          this.$store.dispatch('alert/onAlert', {
            message: 'Updated progress value should be always greater than current value.',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
          return;
        }
        if (parseInt(this.updatedContractProgress) > 100) {
          this.$store.dispatch('alert/onAlert', {
            message: 'Updated progress value should not be greater than 100.',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
          return;
        }
        this.loading = true;
        this.$store.dispatch('swiftuser/saveContractProgress', this.updatedContractProgress);
        setTimeout(() => {
          this.loading = false;
          this.$emit('contract-progress-stored');
        }, 1000);
      },
      cancel () {
        this.loading = true;
        localStorage.removeItem('siteId');
        localStorage.removeItem('scannedTime');
        setTimeout(() => {
          this.$router.push({ name: 'CheckOut' });
        }, 1000);
      },
    },
  };
</script>
